export const LogoMark = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
    <rect width="40" height="40" rx="9" fill="#0A192F" />
    <circle cx="20" cy="20" r="10.5" fill="none" stroke="#38BDF8" strokeWidth="3.2" strokeDasharray="52 14" strokeLinecap="round" transform="rotate(-50 20 20)" />
    <path d="M24 24 L30 30" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ light = false, size = 32, testid = "brand-logo" }) => (
  <span className="inline-flex items-center gap-2.5" data-testid={testid}>
    <LogoMark size={size} />
    <span className={`font-heading font-extrabold tracking-[0.14em] text-[1.05rem] ${light ? "text-white" : "text-slate-900"}`}>
      QORDEL <span className="text-sky-500">360</span>
    </span>
  </span>
);
